import { Component, EventEmitter, Output, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { EmpresasService } from '../../services/empresa/empresas.service';
import { SelecionarEmpresaModal } from '../../modals/selecionar-empresa-modal/selecionar-empresa-modal';
import { SelecionarEnderecoModal } from '../../modals/selecionar-endereco-modal/selecionar-endereco-modal';
import { SnackbarService } from '../../services/snackbar/snackbar.service';
import { DesvincularEndereco } from '../../view/pessoas/cadastrar-pessoa/dialogs/desvincular-endereco/desvincular-endereco';
import { DesvincularEmpresa } from '../../view/pessoas/cadastrar-pessoa/dialogs/desvincular-empresa/desvincular-empresa';

@Component({
  selector: 'app-empresa-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './empresa-picker.html',
  styleUrl: './empresa-picker.scss',
})
export class EmpresaPicker implements OnInit {
  constructor(
    private dialog: MatDialog,
    private empresaService: EmpresasService,
    private snackbarService: SnackbarService,
  ) {}

  empresas: any[] = [];
  enderecos: any[] = [];

  empresaSelecionada: any | null = null;
  enderecoSelecionado: any | null = null;

  empresaDummyModel = '';

  touchedEmpresa = false;
  touchedEndereco = false;

  bloqueado = signal(false);

  @Output() selecaoChange = new EventEmitter<{
    empresa: any | null;
    endereco: any | null;
  }>();

  async ngOnInit() {
    this.empresas =
      await this.empresaService.consultaTelaVincularEmpresaAPessoa();
  }

  abrirModalEmpresas() {
    this.touchedEmpresa = true;

    const dialogRef = this.dialog.open(SelecionarEmpresaModal, {
      data: {
        empresas: this.empresas,
        empresaSelecionada: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe(async (empresa: any) => {
      if (empresa) {
        this.empresaSelecionada = empresa;
        this.enderecoSelecionado = null;

        this.enderecos = empresa.enderecos || [];

        this.emitirSelecao();
      }
    });
  }

  abrirDesvincularEmpresa() {
    const dialogRef = this.dialog.open(DesvincularEmpresa, {
      width: '400px',
      data: {
        empresa: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.empresaSelecionada = null;
        this.enderecoSelecionado = null;
        this.enderecos = [];
        this.emitirSelecao();
        this.snackbarService.success('Empresa desvinculada com sucesso!');
      }
    });
  }

  abrirModalEnderecos() {
    if (!this.empresaSelecionada || this.enderecoSelecionado) return;

    const dialogRef = this.dialog.open(SelecionarEnderecoModal, {
      data: {
        enderecos: this.enderecos,
        empresaSelecionada: this.empresaSelecionada,
        enderecoSelecionado: this.enderecoSelecionado,
      },
    });

    dialogRef.afterClosed().subscribe((endereco: any) => {
      this.touchedEndereco = true;

      if (endereco) {
        this.enderecoSelecionado = endereco;
        this.emitirSelecao();
      }
    });
  }

  abrirDesvincularEndereco() {
    const dialogRef = this.dialog.open(DesvincularEndereco, {
      width: '500px',
      data: {
        empresaSelecionada: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
        this.enderecoSelecionado = null;
        this.snackbarService.success('Endereço desvinculado com sucesso');
        this.emitirSelecao();
      }
    });
  }

  formBloqueado() {
    return this.bloqueado();
  }

  bloquearFormulario(valor: boolean) {
    this.bloqueado.set(valor);
  }

  private emitirSelecao() {
    this.selecaoChange.emit({
      empresa: this.empresaSelecionada,
      endereco: this.enderecoSelecionado,
    });
  }

  formularioValido(): boolean {
    this.touchedEmpresa = true;
    this.touchedEndereco = true;

    return !!(this.empresaSelecionada && this.enderecoSelecionado);
  }
}
